import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/storage";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD-8yCzF5J9P7e1sENud85q46aUlaIIgsQ",
  authDomain: "cityx-app.firebaseapp.com",
  databaseURL: "https://cityx-web.europe-west1.firebasedatabase.app/",
  projectId: "cityx-app",
  storageBucket: "cityx-app.appspot.com",
  messagingSenderId: "960454362186",
  appId: "1:960454362186:web:c1656e33701f2b66a392b3",
  measurementId: "G-1ELF5TJF8S",
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const database = firebase.database();
const storage = firebase.storage();
const firestore = firebase.firestore();

const authObject = firebase.auth;
const databaseObject = firebase.database;
const storageObject = firebase.storage;
const firestoreObject = firebase.firestore;

export {
  auth,
  database,
  storage,
  firestore,
  authObject,
  databaseObject,
  storageObject,
  firestoreObject,
};
